import React from "react";
import type { DesignTokenColor } from "@src/theme";
import type { PanelProps } from "./interface";
import { InternalCard } from "../Card/InternalCard";
import { get } from 'lodash'

type ColorCategory = {
  backgroundColor: DesignTokenColor;
  borderColor: DesignTokenColor;
};

type VariantT = {
  [key in PanelProps['color']]: ColorCategory;
}

type ColorMappingT = {
  light: VariantT;
  dark: VariantT;
};

const COLOR_MAPPING: ColorMappingT = {
  light: {
    error: {
      backgroundColor: 'state.error.backing-1',
      borderColor: 'state.error.primary'
    },
    warning: {
      backgroundColor: 'state.warning.backing-1',
      borderColor: 'state.warning.primary'
    },
    info: {
      backgroundColor: 'state.info.backing-1',
      borderColor: 'state.info.primary'
    },
    success: {
      backgroundColor: 'state.success.backing-1',
      borderColor: 'state.success.primary'
    },
    action: {
      backgroundColor: 'surface.secondary',
      borderColor: 'surface.hover+focused'
    },
    teal: {
      backgroundColor: 'state.teal.backing-1',
      borderColor: 'state.teal.primary'
    }
  },
  dark: {
    error: {
      backgroundColor: 'state.error.secondary',
      borderColor: 'state.error.primary'
    },
    warning: {
      backgroundColor: 'state.warning.secondary',
      borderColor: 'state.warning.primary'
    },
    info: {
      backgroundColor: 'state.info.secondary',
      borderColor: 'state.info.primary'
    },
    success: {
      backgroundColor: 'state.success.secondary',
      borderColor: 'state.success.primary'
    },
    action: {
      backgroundColor: 'controls.primary',
      borderColor: 'controls.outline'
    },
    teal: {
      backgroundColor: 'state.teal.secondary',
      borderColor: 'state.teal.primary'
    }
  }
}

export function Panel(props: PanelProps) {
  const { color, variant = 'light' } = props;
  const { borderColor, backgroundColor } = get(COLOR_MAPPING, `${variant}.${color}`);

  return <InternalCard {...props} borderColor={borderColor} bgColor={backgroundColor} />
}
